const DpoEssl = {
    progressId: null,

    initEspisOdeslat: function () {
        const tlacitko = $("#tlacitkoEspisOdeslat");
        if (!tlacitko.length) {
            return;
        }

        $(document).on("dynabase.force.deactivation", function () {
            tlacitko.addClass("disabled");
        });

        tlacitko
            .off("click")
            .on("click", function (e) {
                e.preventDefault();
                if ($(this).hasClass("disabled")) {
                    Lemo_Alert.addInfo(
                        "Tlačítko je deaktivováno z důvodu provedení změn.<br>"
                        + "Nejdříve uložte rozpracovanou žádost.", "espisInactiveButton"
                    );
                    return;
                }

                DpoEssl.espisOdeslat();
            });
    },

    initEspisPredat: function () {
        const tlacitko = $("#tlacitkoEspisPredat");
        if (!tlacitko.length) {
            return;
        }

        $(document).on("dynabase.force.deactivation", function () {
            tlacitko.addClass("disabled");
        });

        tlacitko
            .off("click")
            .on("click", function (e) {
                e.preventDefault();
                if ($(this).hasClass("disabled")) {
                    Lemo_Alert.addInfo(
                        "Tlačítko je deaktivováno z důvodu provedení změn.<br>"
                        + "Nejdříve uložte rozpracovanou žádost.", "espisInactiveButton"
                    );
                    return;
                }

                DpoEssl.espisPredat();
            });
    },

    espisOdeslat: function () {
        const url = DpoEssl.vratUrl('/ajax/essl/espisOdeslat');
        const postData = DpoEssl.vratPostData();

        DpoEssl.espisAjax(url, postData);
    },

    espisPredat: function () {
        const url = DpoEssl.vratUrl('/ajax/essl/espisPredat');
        const postData = DpoEssl.vratPostData();

        DpoEssl.espisAjax(url, postData);
    },

    espisAjax: function(url, postData) {
        let redirectUrl = null;
        if (url.includes("espisPredat")) {
            redirectUrl = window.location.href;
            redirectUrl = redirectUrl.replace("/item/edit", "/item/detail");

            console.log(redirectUrl);
        }

        $.ajax({
            type: "post",
            url: url,
            data: postData,
            dataType: "json",
            global: false,
            beforeSend: function () {
                DynaBase_Overlay.show();

                Lemo_Alert.closeAll();
                let text = '<p>ESPIS zpracování ... <span id="progress-eta"></span></p>';
                text += '<div id="progress" class="progress text-center mt-1 mb-2">';
                text += '    <div class="progress-bar progress-bar-striped active" role="progressbar" style="width: 0;">0%</div>';
                text += '</div>';
                Lemo_Alert.setShowCloseButton(false);
                Lemo_Alert.setCloseOnClick(false);
                Lemo_Alert.addInfo(text, 'espisZpracovani', 0);

                DpoEssl.progressId = window.setInterval(function () {
                    DpoEssl.progressInfo(postData["uuid"]);
                }, 2500);
            },
            complete: function () {
                Lemo_Alert.closeById("espisZpracovani");

                window.clearInterval(DpoEssl.progressId);
                DpoEssl.progressId = null;

                if (null === redirectUrl) {
                    DynaCore_Item.miniformReload(103, 4);
                }

                DynaBase_Overlay.hide();
            },
            success: function (r) {
                if (r.hasOwnProperty("messages")) {
                    Lemo_Alert.addMany(r.messages);
                }

                if (r.hasOwnProperty("data")) {
                    const data = r["data"];
                    if (data.hasOwnProperty("cisloJednaci")) {
                        $("#espiscj").val(data["cisloJednaci"]);
                    }
                    if (data.hasOwnProperty("spisovaZnacka")) {
                        $("#espissz").val(data["spisovaZnacka"]);
                    }
                    if (data.hasOwnProperty("espispredano")) {
                        $("#espispredano").attr("checked", true).prop("checked", true);
                    }
                }

                if (r.hasOwnProperty('status') && true !== r["status"]) {
                    $("#espischyba").attr('checked', true).prop('checked', true);
                }

                if (null !== redirectUrl) {
                    DynaBase_Overlay.show();

                    DpoHromadnaZmenaStavu.progressId = window.setInterval(function () {
                        window.location.href = redirectUrl;
                    }, 3000);
                }
            },
            error: function () {
                Lemo_Alert.addDanger("Zpracování selhalo.", "esslError");
            }
        });
    },

    progressInfo: function (uuid) {
        $.ajax({
            type: "post",
            url: "/ajax/essl/progressInfo",
            data: {"uuid": uuid},
            dataType: "json",
            global: false,
            success: function (r) {
                let data = r.data;

                const progressBar = $('#progress');
                if (progressBar.length) {
                    progressBar.find('.progress-bar').text(data["procent"] + '%');
                    progressBar.find('.progress-bar').css('width', data["procent"] + '%');
                }
                const progressBarEta = $('#progress-eta');
                if (progressBarEta.length) {
                    if (null !== data["eta"]) {
                        progressBarEta.text(" Zbývá: " + data["eta"]);
                    } else {
                        progressBarEta.text(" Zbývá: neznámo");
                    }
                }
            }
        });
    },

    vratUrl(route) {
        let url = window.location.protocol + "//" + window.location.host;
        url += route;

        const section = $('#idSection');
        if (section.length && section.val()) {
            url += '/' + section.val();
        }

        const item = $('#idItem');
        if (item.length && item.val()) {
            url += '/' + item.val();
        }

        return url;
    },

    vratPostData() {
        let postData = {};

        const _ch = $("#_ch");
        if (_ch.length) {
            postData["_ch"] = _ch.val();
        }

        postData["uuid"] = crypto.randomUUID();

        return postData;
    }
}

$(document).ready(function () {
    DpoEssl.initEspisOdeslat();
    DpoEssl.initEspisPredat();
});
